import { render, staticRenderFns } from "./DetailReports.vue?vue&type=template&id=1dbbd460"
import script from "./DetailReports.vue?vue&type=script&lang=js"
export * from "./DetailReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports